import { Location } from '@angular/common';
import { ErrorHandler } from '@angular/core';
import { PageOptions } from '~/app/open-age/core/models/page-options.model';
import { IApi } from '~/app/open-age/core/services/api.interface';
import { PagerBaseComponent } from './pager-base.component';
import { PagerOptions } from './pager-options.model';

export class PagerModel<TModel> extends PagerBaseComponent<TModel>  {
  constructor(options: {
    api: IApi<TModel>,
    properties?: TModel,
    fields?: {
      id: 'id' | string,
      timeStamp: 'timeStamp' | string
    },
    watch?: number,
    cache?: IApi<TModel>,
    map?: (obj: any) => TModel,
    pageOptions?: {
      limit: number,
      offset?: number,
      sort?: string,
      desc?: boolean
    } | PageOptions,
    maxPagesToShow?: number,
    filters?: any[],
    addOperator?: boolean,
    location?: Location,
    errorHandler?: ErrorHandler
  } | PagerOptions<TModel>) {
    super(options);
  }
}
